import React from 'react';
import { IonInput } from '@ionic/react';
import { Field } from 'formik';
import { useTheme } from 'src/modules/card/context/theme';
import { Text } from '../Text';

export function LastNameField({ name = 'userInformations.name' }) {
  const theme = useTheme();
  return (
    <Field name={name}>
      {({ form, field }) => (
        <>
          <Text
            fontWeigth="bold"
            width="100%"
            justifyContent="flex-start"
            color={theme?.color?.title}
            paddingBottom=".2em"
            paddingTop="2em"
          >
            Nom
          </Text>
          <IonInput
            data-cy="name_input"
            type="text"
            maxlength={15}
            placeholder="Mon nom"
            value={field.value}
            onIonChange={e => form.setFieldValue('userInformations.name', e.detail.value)} />
        </>
      )}
    </Field>
  );
}
